var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_45_4163)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H24V24H0V0Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.69458 20.2026V11.6026L23.9999 11.6159V13.9919L22.2306 15.8826L23.9999 17.7906V20.2159H21.1759L19.6746 18.5599L18.1839 20.2226L8.69458 20.2026Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.71594 19.26V12.5493H15.4066V14.0946H11.5586V15.144H15.3146V16.664H11.5586V17.6947H15.4066V19.26H9.71594Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3772 19.26L18.5265 15.9L15.3772 12.5493H17.8145L19.7385 14.676L21.6679 12.5493H23.9999V12.6026L20.9185 15.9L23.9999 19.164V19.26H21.6439L19.6865 17.112L17.7479 19.26H15.3772Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.40786 3.9693H13.0972L14.3932 6.91197V3.9693H18.9479L19.7332 6.17463L20.5212 3.9693H23.9999V12.5693H5.61853L9.40786 3.9693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1066 4.90393L7.12927 11.6093H9.17194L9.73327 10.2666H12.7773L13.3386 11.6093H15.4319L12.4666 4.90393H10.1079H10.1066ZM10.3626 8.76126L11.2559 6.6266L12.1479 8.76126H10.3626Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4026 11.6079V4.90259L18.2733 4.91325L19.7506 9.03459L21.2373 4.90259H23.9999V11.6079L22.2226 11.6239V7.01725L20.5439 11.6079H18.9213L17.2079 7.00259V11.6079H15.4026Z",
    fill: "#016FD0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45_4163"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/Amex.7136d927626b33fce2b6baaacebee513.svg";
export { ForwardRef as ReactComponent };